import { Constants } from '@pwc/pwc-deals-web-common';

export const CALC_ENGINE_ACTION_PREFIX = 'calcEngine';
export const CALC_ENGINE_SCHEDULER_TIMEOUT = 400;
export const COMPOSITE_KEY_DELIMITER = '__||__';
export const TOTALS_KEY = 'totals';
export const LABEL_KEY = 'label';
export const ACTIVE_KEY = 'active';
export const CALC_ENGINE_KEY = 'calcEngine';
export const ALL_ADJUSTMENTS_KEY = 'All Adjustments';
export const ADJUSTMENT_SUMS_BY_CODE_KEY = 'adjustmentSumsByDocument';
export const TOGGLED_ADJUSTMENT_SUMS_BY_CODE_KEY =
  'toggledAdjustmentSumsByDocument';
export const ADJUSTMENT_TYPES_BY_CODE_KEY = 'adjustmentsByDocument';
export const ADJUSTMENT_TOGGLES_BY_DOCUMENT_KEY = 'adjustmentTogglesByDocument';
export const FACT_CALCULATIONS_KEY = 'factCalculations';
export const TIME_PERIODS_BY_CODE_KEY = 'timePeriodsByCode';
export const TIME_PERIOD_METADATA_BY_CODE_KEY = 'timePeriodMetadataByDocument';
export const TIME_PERIOD_FLAGS_KEY = 'timePeriodFlags';
export const TABLE_VIEW_COLUMNS_METADATA_KEY = 'tableViewDisplayColumns';
export const CHART_VIEW_COLUMNS_METADATA_KEY = 'chartViewDisplayColumns';
export const LONG_DESCRIPTIONS_BY_CODE_KEY = 'longDescriptionsByCode';
export const LINKED_ADJUSTMENTS_BY_DOCUMENT_KEY = 'linkedAdjustmentsByDocument';
export const STRUCTURED_ANALYSIS_VIEW_KEY = 'structuredAnalysisView';
export const REPORTED_REVENUE_KEY = 'Reported Revenue';
export const ADJUSTED_REVENUE_KEY = 'Adjusted Revenue';
export const REPORTED_EBITDA_KEY = 'Reported EBITDA';
export const ADJUSTED_EBITDA_KEY = 'Adjusted EBITDA';
export const REVENUE_ADJUSTMENTS_KEY = 'Revenue Adjustments';
export const REVENUE_CATEGORY = 'Revenue';
export const ADJUSTMENT_CATEGORY_REVENUES_PANDL = 'Revenues (P&L)';
export const EBITDA_FLAG = 'EBITDA';

export const CURRENT_ASSETS_CATEGORY = 'Current assets';
export const CURRENT_ASSETS_KEY = 'Current Assets';
export const CURRENT_LIABILITIES_CATEGORY = 'current liabilities';
export const CURRENT_LIABILITIES_KEY = 'Current Liabilities';
export const REPORTED_WORKING_CAPITAL_KEY = 'Reported Working Capital';
export const QOFE_BRIDGE_CHART_TITLE = 'EBITDA Adjustment Bridge';

export const EMPTY_VALUE = Symbol('empty value');
export const ROW_TYPE_ADJUSTMENT = 'adjustment';
export const ROW_TYPE_FACT = 'fact';
export const OTHER_CONSIDERATIONS_TOTALS_OVERRIDE_TEXT = '+/-NQ';
export const NQ_EBITDA_CONTRIBUTION = '(+/-NQ)';
export const EMPTY_DATA_MARKER = '-';
export const EBITDA = 'EBITDA';
export const WORKING_CAPITAL = 'Working Capital';
export const NWC_CHART_TITLE = 'Adjusted Net Working Capital';

export const REPORTED_DEBT_KEY = 'Reported Debt';
export const REPORTED_CASH_KEY = 'Reported Cash';
export const NET_DEBT_KEY = 'Net Debt';
export const DEBT_LIKE_ITEMS_KEY = 'Debt-Like Items';
export const NET_DEBT_AND_DEBT_LIKE_KEY = 'Net Debt and Debt-Like';

export const QUALITY_OF_EARNINGS_DISPLAY_NAME = 'Quality of Earnings';
export const NET_WORKING_CAPITAL_DISPLAY_NAME = 'Net Working Capital';
export const DEBT_AND_DEBT_LIKE_DISPLAY_NAME = 'Debt and Debt Like';

export const STRUCTURED_ANALYSIS_V1_TITLES = [
  QUALITY_OF_EARNINGS_DISPLAY_NAME,
  NET_WORKING_CAPITAL_DISPLAY_NAME,
  DEBT_AND_DEBT_LIKE_DISPLAY_NAME,
];
/**
 * @deprecated Title will be editable
 */
export const STRUCTURED_DISPLAY_NAME_BY_CODE = {
  [Constants.QUALITY_OF_EARNINGS]: QUALITY_OF_EARNINGS_DISPLAY_NAME,
  [Constants.NET_WORKING_CAPITAL]: NET_WORKING_CAPITAL_DISPLAY_NAME,
  [Constants.DEBT_AND_DEBT_LIKE]: DEBT_AND_DEBT_LIKE_DISPLAY_NAME,
};

export const CONTENT_SUBTYPES = {
  UNDEFINED: 0,
  UNSTRUCTURED: 100,
  QUALITY_OF_EARNINGS: 200,
  NET_WORKING_CAPITAL: 300,
  DEBT_DEBT_LIKE: 400,
  PROFIT_AND_LOSS: 500,
  BALANCE_SHEET: 600,
};

export const STRUCTURED_DISPLAY_NAME_BY_SUBTYPE = {
  200: QUALITY_OF_EARNINGS_DISPLAY_NAME,
  300: NET_WORKING_CAPITAL_DISPLAY_NAME,
  400: DEBT_AND_DEBT_LIKE_DISPLAY_NAME,
};

export const COLUMN_HIGHLIGHT_CLASS = 'column-highlight';
